import {  Col, Container } from 'react-bootstrap';

function Sidebar ({children}) {
    return (
        <Col lg={3} md={12} className="man-sidebar-wrapper">
            <Container className='man-sidebar'>
                {children}
            </Container>
        </Col>
    )
};

export default Sidebar;